var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-component"},_vm._l((_vm.tags),function(tag,index){return _c('span',{key:index},[_vm._v(_vm._s(tag))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }